@if (inlineApplicationDetails.showAppView) {
<wm-app class="view"></wm-app>
}@else if (inlineApplicationDetails.showAppSummary) { @if
(!janusApplicationSummaryDetails.application) {
<div
  style="display: flex;justify-content: center;align-items: center;"
>
  <mat-progress-spinner mode="indeterminate" diameter="48">
  </mat-progress-spinner>
</div>
}@else {
<app-application-status-card
  [currentActivity]="inlineApplicationDetails.currentActivity"
  [hasFees]="inlineApplicationDetails.hasFees"
  [fees]="inlineApplicationDetails.fees"
  [applicationId]="isChildApplication ? childApplicationId : applicationId"
  [statusCode]="
    isChildApplication ? 1 : inlineApplicationDetails.applicationStatusCode
  "
  [applicationNumber]="
    inlineApplicationDetails.combinedApplicationNumber || janusApplicationSummaryDetails.application?.combinedApplicationNumber || applicationNo
  "
  [submitter]="inlineApplicationDetails?.submitter?.userName || janusApplicationSummaryDetails?.submitter?.userName"
  [appDate]="applicationDate"
  [startedDate]="inlineApplicationDetails?.startedOn || janusApplicationSummaryDetails?.application?.startedOn"
  [linkedApplications]="inlineApplicationDetails?.linkedApplications || []"
></app-application-status-card>
<app-application-actions
  [statusCode]="
    isChildApplication ? 1 : inlineApplicationDetails.applicationStatusCode
  "
  [appId]="isChildApplication ? childApplicationId : applicationId"
  [applicationNumber]="
    inlineApplicationDetails.combinedApplicationNumber || janusApplicationSummaryDetails.application?.combinedApplicationNumber
  "
  [workflowId]="inlineApplicationDetails.workflowId || janusApplicationSummaryDetails.workflowId"
  [versionId]="inlineApplicationDetails.workflowVersionId || janusApplicationSummaryDetails.workflowVersionId"
></app-application-actions>
<wm-edit-application-janus
  [appID]="isChildApplication ? childApplicationId : applicationId"
  [janusApplicationSummaryDetails]="janusApplicationSummaryDetails"
></wm-edit-application-janus>
} }@else {
<!-- Added by Amisha on 2026-08-12. -->
<!-- Reason: host one reusable share modal for all inline activity rows. -->
<wm-share-activity [applicationId]="applicationId"></wm-share-activity>
@if (inlineApplicationDetails.categoriesFetchError) {
<div class="categories-list-fetch-error-container">
  <wm-common-icon
    [data]="{ iconName: inlineApplicationStaticDetails.errorIcon }"
  ></wm-common-icon>
  <wm-common-text
    [data]="{ text: inlineApplicationDetails.categoriesFetchError }"
  ></wm-common-text>
</div>
}@else { 
  @if (!inlineApplicationDetails.isCategoryFetching) {  
        @if(isChildApplication){
          <div class="child-application-header">
            <div
              class="parent-application-header-typography"
              (click)="onParentApplicationInChildApplicationHeaderClick()"
            >
              <wm-common-text
                [data]="{text:`${parentApplicationDetails.name} ${parentApplicationDetails.number}`}"
              ></wm-common-text>
            </div>
            <wm-common-text
              [data]="{text:`> ${inlineApplicationDetails.workflowName || janusApplicationSummaryDetails.application.name} ${inlineApplicationDetails.applicationNumber || janusApplicationSummaryDetails.application.applicationNumber}`}"
            ></wm-common-text>
          </div>
      }

      <app-application-status-card
        [currentActivity]="inlineApplicationDetails.currentActivity"
        [hasFees]="inlineApplicationDetails.hasFees"
        [fees]="inlineApplicationDetails.fees"
        [applicationId]="isChildApplication ? childApplicationId : applicationId"
        [statusCode]="
          isChildApplication ? 1 : inlineApplicationDetails.applicationStatusCode
        "
        [applicationNumber]="
          inlineApplicationDetails.combinedApplicationNumber || janusApplicationSummaryDetails.application?.combinedApplicationNumber || applicationNo
        "
        [submitter]="inlineApplicationDetails?.submitter?.userName || janusApplicationSummaryDetails?.submitter?.userName"
        [appDate]="applicationDate"
        [startedDate]="inlineApplicationDetails?.startedOn || janusApplicationSummaryDetails?.application?.startedOn"
        [linkedApplications]="inlineApplicationDetails?.linkedApplications || []"
      ></app-application-status-card>


<div class="category-action-relate-container">
  <!-- Updated by Amisha on 2026-09-22.
       Reason: provide mobile left/right navigation and keep shortcut-selected categories visible. -->
  <div class="category-list-navigation">
    <button
      type="button"
      class="category-scroll-button category-scroll-button-left"
      aria-label="Scroll application categories left"
      [disabled]="!canScrollCategoriesLeft"
      (click)="scrollCategories('left')"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
  <div
    #categoryListContainer
    class="category-list-container"
    (scroll)="onCategoryListScroll()"
  >
    @for (category of inlineApplicationDetails.applicationCategories; track
    $index) {
    <div
      class="category-list-button janus-category-list-button"
      [class.janus-active-category-list-button]="
        category.id === inlineApplicationDetails.activeApplicationCategory.id
      "
    >
      <div
        class="category-list-error-icon"
        [class.action-required-category]="
          category.hasInProgressActivities === true
        "
      >
        <wm-common-icon
          [data]="{ iconName: inlineApplicationStaticDetails.errorIcon }"
        ></wm-common-icon>
      </div>
      <wm-common-button
        [data]="getCategoryListButtonData(category)"
      ></wm-common-button>
    </div>
    }
  </div>
    <button
      type="button"
      class="category-scroll-button category-scroll-button-right"
      aria-label="Scroll application categories right"
      [disabled]="!canScrollCategoriesRight"
      (click)="scrollCategories('right')"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
  @if (onlyAttachments === false && onlyNotes === false){
  <!-- Updated by Amisha on 2026-09-16.
       Reason: provide a class hook so mobile can place the existing Actions controls above
       the horizontally scrollable category tabs without changing their behavior. -->
  <div
    class="application-actions-relate-container"
  >
    <app-application-actions
      [statusCode]="
        isChildApplication ? 1 : inlineApplicationDetails.applicationStatusCode
      "
      [appId]="isChildApplication ? childApplicationId : applicationId"
      [applicationNumber]="
        inlineApplicationDetails.combinedApplicationNumber || janusApplicationSummaryDetails.application?.combinedApplicationNumber
      "
      [workflowId]="inlineApplicationDetails.workflowId || janusApplicationSummaryDetails.workflowId"
      [versionId]="inlineApplicationDetails.workflowVersionId || janusApplicationSummaryDetails.workflowVersionId"
    ></app-application-actions>
    <div
      class="relate-to-permit-icon"
      matTooltip="Relate to Permit"
      matTooltipPosition="above"
      (click)="onRelateToPermitIconClick()"
    >
      <wm-common-icon
        class="relate-to-permit-common-icon"
        [data]="{ iconName: inlineApplicationStaticDetails.relateToPermitIcon }"
      ></wm-common-icon>
    </div>
  </div>
  }@else {
  <div></div>
  }
</div>

}@else {
<div
  class="inline-card-loader"
  style="display: flex;justify-content: center;align-items: center;flex-direction: column;row-gap: 5px;"
>
  <mat-progress-spinner mode="indeterminate" diameter="48">
  </mat-progress-spinner>
  <wm-common-text
    [data]="{ text: inlineApplicationDetails.categoryLoadingMsg }"
  ></wm-common-text>
</div>
} } @if (inlineApplicationDetails.activeApplicationCategory?.id) {
<div class="category-card">
  @if
  (inlineApplicationDetails.activeApplicationCategory.hasInProgressActivities
  === true) {
  <div class="action-required-category-header">
    <wm-common-text
      [data]="{ text: inlineApplicationDetails.activeApplicationCategory.name }"
    ></wm-common-text>
    <wm-common-icon
      [data]="{ iconName: inlineApplicationStaticDetails.errorIcon }"
    ></wm-common-icon>
  </div>
  }@else {
  <wm-common-text
    [data]="{ text: inlineApplicationDetails.activeApplicationCategory.name }"
  ></wm-common-text>
  } @if (inlineApplicationDetails.errorFetchingActivities) {
  <div class="activity-fetch-error-container">
    <wm-common-icon
      [data]="{ iconName: inlineApplicationStaticDetails.errorIcon }"
    ></wm-common-icon>
    <wm-common-text
      [data]="{ text: inlineApplicationDetails.errorFetchingActivities }"
    ></wm-common-text>
  </div>
  }@else { @if (inlineApplicationDetails.isfetchingActivities === false) { @for
  (activityDetails of inlineApplicationDetails.activitiesBasedOnCategory; track
  $index) {
  <div class="category-activity-main-container">
    <div
      class="category-activity-header"
      (click)="toggleAccordion(activityDetails, $index)"
    >
      @if(activityDetails.isActionRequired){
      <div class="action-required-category-activity-header">
        <wm-common-text
          [data]="{ text: activityDetails.activity.activityName }"
        ></wm-common-text>
        <wm-common-icon
          [data]="{ iconName: inlineApplicationStaticDetails.errorIcon }"
        ></wm-common-icon>
      </div>
      }@else {
      <wm-common-text
        [data]="{ text: activityDetails.activity.activityName }"
      ></wm-common-text>
      }

      <!-- Added by Amisha on 2026-08-12. -->
      <!-- Reason: expose activity-wise sharing beside each activity accordion control. -->
      <div class="activity-header-actions">
        @if (activityDetails.activity.activity?.canBeShared !== false) {
        <button
          type="button"
          class="activity-share-button"
          [disabled]="
            sharingActivityDataId === activityDetails.activity.activityDataId
          "
          (click)="openShareActivity(activityDetails, $index, $event)"
          [attr.aria-label]="'Share ' + activityDetails.activity.activityName"
          title="Share activity"
        >
          @if (sharingActivityDataId ===
          activityDetails.activity.activityDataId) {
          <mat-progress-spinner
            mode="indeterminate"
            diameter="18"
          ></mat-progress-spinner>
          } @else {
          <span class="material-icons" aria-hidden="true">share</span>
          <span>Share</span>
          }
        </button>
        } @if (activityDetails.isActivityAccordionOpen === true) {
        <ng-template #upArrowTemplate>
          <wm-common-icon
            [data]="{ iconName: inlineApplicationStaticDetails.upArrowIcon }"
          ></wm-common-icon>
        </ng-template>
        <wm-common-button
          class="arrowButton"
          [data]="
            getActivityAccordionClick(
              upArrowTemplate,
              'close',
              activityDetails,
              $index
            )
          "
        ></wm-common-button>
        }@else {
        <ng-template #downArrowTemplate>
          <wm-common-icon
            [data]="{ iconName: inlineApplicationStaticDetails.downArrowIcon }"
          ></wm-common-icon>
        </ng-template>
        <wm-common-button
          class="arrowButton"
          [data]="
            getActivityAccordionClick(
              downArrowTemplate,
              'open',
              activityDetails,
              $index
            )
          "
        ></wm-common-button>
        }
      </div>
    </div>
    @if (activityDetails.isActivityAccordionOpen === true) { @if
    (activityDetails.errorFetching) {
    <div class="activity-accordion-fetch-error-container">
      <wm-common-icon
        [data]="{ iconName: inlineApplicationStaticDetails.errorIcon }"
      ></wm-common-icon>
      <wm-common-text
        [data]="{ text: activityDetails.errorFetching }"
      ></wm-common-text>
    </div>
    }@else { @if (activityDetails.isFetching === false) {
    <div class="category-activity-container">

      <wm-activity-view #activityViewItem [activity]="activityDetails.activity.activity" [form]="activityDetails.form"
          [applicationId]="isChildApplication?childApplicationId : applicationId" [isPreview]="false"
          [isTestApplication]="inlineApplicationDetails.isTestApplication"></wm-activity-view>


      <div class="category-activity-actions-container">
        <ng-template #actionsLoaderTemplate>
          <mat-progress-spinner mode="indeterminate" diameter="20">
          </mat-progress-spinner>
        </ng-template>
        @if (activityDetails.showSaveBtn === true) {
        @if(inlineApplicationDetails.activeApplicationCategory?.staticCategoryType
        !== 'submit'){
        <wm-common-button
          [data]="
            onSaveButtonClick(
              actionsLoaderTemplate,
              activityDetails.activity.activity,
              $index
            )
          "
        ></wm-common-button>
        } } @if(activityDetails.showSubmitButton === true){
        <wm-common-button
          [data]="
            onSubmitButtonClick(
              actionsLoaderTemplate,
              activityDetails.activity.activity,
              $index
            )
          "
        ></wm-common-button>
        }
      </div>
    </div>
    }@else {
    <div class="activity-fetch-accordion-loader-container">
      <mat-progress-spinner mode="indeterminate" diameter="48">
      </mat-progress-spinner>
      <wm-common-text
        [data]="{ text: 'Retrieving activity, please wait…' }"
      ></wm-common-text>
    </div>
    } } }
  </div>
  } @if(inlineApplicationDetails.activeApplicationCategory?.staticCategoryType
  && inlineApplicationDetails.activeApplicationCategory?.staticCategoryType !==
  'submit'){
  <div class="category-activity-main-container">
    <div class="category-activity-header">
      <wm-common-text
        [data]="{
          text: inlineApplicationDetails.activeApplicationCategory.name
        }"
      ></wm-common-text>
    </div>
    <div class="category-activity-container">
      @if (inlineApplicationDetails.activeApplicationCategory.staticCategoryType
      === 'attachments') {
      <!-- added by priya 11-02-2026 -->
      <wm-application-required-documents
        [applicationId]="
          isChildApplication ? childApplicationId : applicationId
        "
        (attachmentsChanged)="onAttachmentsChanged($event)"
      ></wm-application-required-documents>

      <!-- end by priya 11-02-2026 -->
      }@else if
      (inlineApplicationDetails.activeApplicationCategory.staticCategoryType ===
      'notes') {
      <app-common-notes
        [applicationId]="
          isChildApplication ? childApplicationId : applicationId
        "
        [applicationNumber]="
          inlineApplicationDetails.combinedApplicationNumber || janusApplicationSummaryDetails.application
            ?.combinedApplicationNumber || ''
        "
        (notesChanged)="onNotesChanged($event)"
      >
      </app-common-notes>
      }@else if(inlineApplicationDetails.activeApplicationCategory.staticCategoryType==='view-application'){
      @if (!janusApplicationSummaryDetails.application) {
      <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
        <mat-progress-spinner mode="indeterminate" diameter="48">
        </mat-progress-spinner>
        <p>Fetching details...</p>
      </div>
      }@else {
      <wm-edit-application-janus
        [appID]="isChildApplication ? childApplicationId : applicationId"
        [janusApplicationSummaryDetails]="janusApplicationSummaryDetails"
      ></wm-edit-application-janus>
      } }
    </div>
  </div>
  } }@else {
  <div class="activities-loading-container">
    <mat-progress-spinner mode="indeterminate" diameter="48">
    </mat-progress-spinner>
    <wm-common-text
      [data]="{ text: 'Retrieving activities, please wait…' }"
    ></wm-common-text>
  </div>
  } }
</div>
} }
